import { Turbo } from '@hotwired/turbo-rails'
import '@popperjs/core'
import { Tooltip, Popover } from 'bootstrap'
import 'chartkick/chart.js'
import './src/chart-zero-series'

import 'stylesheets/application.scss'
import './controllers'
import initCopyClips from './src/copy-clip'
import bsConfirm from './src/bs-confirm'
import { initChat } from './src/chat'

require.context('./images', true)

Turbo.config.forms.confirm = bsConfirm

const initTooltips = function() {
  [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]')).map(function(el) {
    return Tooltip.getOrCreateInstance(el)
  });
  [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]')).map(function(el) {
    return Popover.getOrCreateInstance(el)
  })
}

const initComponents = function() {
  initTooltips()
  initCopyClips()
}

// A popup that loads its content on demand cannot rely on the frame becoming visible: a modal is
// display:none until Bootstrap shows it, and a lazy frame inside one is not reliably observed.
// Loading it when the popup opens is deterministic, and keeps the content off the initial page.
document.addEventListener('show.bs.modal', function(event) {
  const frame = event.target.querySelector('turbo-frame[loading="lazy"]')
  if (frame) frame.setAttribute('loading', 'eager')
})

document.addEventListener('turbo:load', initComponents)
document.addEventListener('turbo:load', initChat)
document.addEventListener('turbo:frame-load', initComponents)
